import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import ChatBackIcon from "../../../../../assets/svg-fc/ChatBackIcon";
import WhatsAppBannerIcon from "../../../../../assets/svg-fc/WhatsAppBannerIcon";
import palette from "../../../../../theme/palette";
import youCaterAvatar from "../../../../../assets/images/youCaterAvatar.png";
import "./ChatHeader.scss";

interface ChatHeaderProps {
	vendorName: string;
	whatsAppIconVisible: boolean;
	showBackButton?: boolean;
	onSocialClick?: () => void;
	onBackClick?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
	vendorName,
	onSocialClick,
	onBackClick,
	whatsAppIconVisible,
	showBackButton = true,
}) => {
	return (
		<Box className="chatHeader">
			<Box className="chatHeaderContent">
				<Box className="chatHeaderLeft">
					<Box className="chatHeaderAvatar">
						{showBackButton && (
							<Box className="chatHeaderBackIcon" onClick={onBackClick}>
								<ChatBackIcon />
							</Box>
						)}
						<Avatar className="avatarBackground" src={youCaterAvatar} />
					</Box>
					<Typography className="eventName">{vendorName}</Typography>
				</Box>
				<Box className="chatHeaderRight">
					{whatsAppIconVisible && (
						<Box className="iconButton" onClick={onSocialClick}>
							<WhatsAppBannerIcon size="24" fill={palette.grey[1000]} />
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default ChatHeader;
